/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Enum representing the status of an integration.
 * @export
 */
export const IntegrationVisibility = {
    Public: 'Public',
    Private: 'Private',
    Hidden: 'Hidden'
};
export function instanceOfIntegrationVisibility(value) {
    for (const key in IntegrationVisibility) {
        if (Object.prototype.hasOwnProperty.call(IntegrationVisibility, key)) {
            if (IntegrationVisibility[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function IntegrationVisibilityFromJSON(json) {
    return IntegrationVisibilityFromJSONTyped(json, false);
}
export function IntegrationVisibilityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function IntegrationVisibilityToJSON(value) {
    return value;
}
export function IntegrationVisibilityToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
